
(function(template){
  define('vue!optionalClassProgram/components/classComponents/optionalComponents/singleClassComponent',[
    "Vue",
    "helpers",
    "vuex",
    "moment",
    'vue!../../helperComponents/checkbox',
    "vue!../classDescriptionComponent",

  ], function (
    Vue,
    helpers,
    vuex,
    moment,
    checkbox,
    classDescriptionComponent
  ) {
    return {
      template: template,
      name: "",
      props: ['customerID','propertyName','item','invalidGroupClasses'],
      data: function () {
        return {
            isValid:true,
            error: ""
        }
      },
      computed: _.extend(
        vuex.mapState(['users','currentlyBookingClassProgram']), {
            isGroupedClassPossible: function(){
                if(this.invalidGroupClasses[this.item.SpaClassId]){
                    this.error = this.singleClassErrorMessage(this.item,this.customerID,true)
                    return false
                }
                return true;
            },
            canSelectIndividualOptClass: function(){
               
                //if bookMode is First, then all the cascaded classes have to be booked together.That is, user cannot modify their choice.
                return this.item.CascadeOption == "N" || this.currentlyBookingClassProgram.BookMode == "A"
            }

        }),
      components: {
          'classDescriptionComponent':classDescriptionComponent,
          'checkbox':checkbox
      },
      methods: {
          handleCheckBoxClick: function (checked, item, parentCascade, cascadeCheckbox) {
              var action = !checked ? 'add' : 'remove'
              var self = this;
              this.isValid = this.verifyAge(item, this.customerID) 

              if (this.isValid && this.canSelectIndividualOptClass)
                  this.$store.commit('configureOptionalSpaItemId', {
                      userId: this.customerID,
                      SpaClassId: item.SpaClassId,
                      action: action
                  })
              else this.error = this.singleClassErrorMessage(item,this.customerID,true)
          },
          isOptionalClassAdded: function (itemId, propertyName) {
              var optionalClassListIds = this.users[this.customerID]['optionalClassListIds'] || {}
              return !!optionalClassListIds[itemId]
          },
      },
    }
  })
})('<div> <p class="inner-service-error"><strong v-if="!isValid || !isGroupedClassPossible">{{error}}</strong></p> <checkbox :selected="isOptionalClassAdded(item.SpaClassId,propertyName)" :item="item" :parentCascade="propertyName" @handle-checkbox-click="handleCheckBoxClick"> </checkbox> <classDescriptionComponent v-bind:item="item" v-bind:cascadeOption="propertyName"></classDescriptionComponent> </div>');
